import { Box, Text, VStack } from "@chakra-ui/react";
import NavItemComponent from "./NavItemComponent";
import type { NavSectionProps } from "./types";
import { sectionHeaderStyles } from "./styles";

const NavSection = ({ title, items, currentPath, onNavigate, isCollapsed = false }: NavSectionProps) => (
  <Box>
    {!isCollapsed && <Text {...sectionHeaderStyles}>{title}</Text>}
    <VStack gap={1} align="stretch">
      {items.map((item) => (
        <NavItemComponent
          key={item.path}
          item={item}
          isActive={currentPath === item.path || currentPath.startsWith(`${item.path}/`)}
          onClick={() => onNavigate(item.path)}
          isCollapsed={isCollapsed}
        />
      ))}
    </VStack>
  </Box>
);

export default NavSection; 